import { useQuery } from "@tanstack/react-query"
import { useCurrentOrganization } from "@/modules/organizations/hooks/use-organizations"
import { userService } from "@/modules/users/infrastructure/user-service"
import { getUserRoleNames } from "@/modules/users/utils/user-roles"

/**
 * Only accepted TeamMembers can be assigned resource access — the org owner already has full
 * access, matching AssignResourceAccessHandler's server-side check.
 */
export function useEligibleAssignees() {
  const org = useCurrentOrganization()
  const orgId = org?.id ?? ""

  const query = useQuery({
    queryKey: ["organization-users", orgId],
    queryFn: () => userService.getOrganizationUsers(orgId),
    enabled: !!orgId,
  })

  const eligible = (query.data?.users ?? []).filter(
    (u) => u.status === "Accepted" && getUserRoleNames(u).includes("TeamMember"),
  )

  return { ...query, eligible }
}
